import inputCommon from './_input_common';

export const inputDetailAction = () => {
    inputCommon();

    // チェックの自動入力
    /*
    $('input[name="appeal_point_lunch1_add"]').on('keyup change', () => {
        $('input[name="appeal_point_lunch[]"]').eq(0).prop('checked', true)
    })
    $('input[name="appeal_point_lunch2_add"]').on('keyup change', () => {
        $('input[name="appeal_point_lunch[]"]').eq(1).prop('checked', true)
    })
    $('input[name="appeal_point_lunch3_add"]').on('keyup change', () => {
        $('input[name="appeal_point_lunch[]"]').eq(2).prop('checked', true)
    })
    
    $('input[name="appeal_point_dinner1_add"]').on('keyup change', () => {
        $('input[name="appeal_point_dinner[]"]').eq(0).prop('checked', true)
    })
    $('input[name="appeal_point_dinner2_add"]').on('keyup change', () => {
        $('input[name="appeal_point_dinner[]"]').eq(1).prop('checked', true)
    })
    $('input[name="appeal_point_dinner3_add"]').on('keyup change', () => {
        $('input[name="appeal_point_dinner[]"]').eq(2).prop('checked', true)
    })
    
    $('input[name="come_child_limit"]').on('keyup change', () => {
        $('input[name="come_child"]').eq(2).prop('checked', true)
    })
    */

    const autoCheck = (baseNameVal, baseNameEq, detailNameVal) => {

        // 自動チェック入力
        $(`input[name="${detailNameVal}"]`).on('keyup change', () => {
            $(`input[name="${baseNameVal}"]`).eq(baseNameEq).prop('checked', true)
        })

        //  内容が入力されたときはチェックは外せない
        $(`input[name="${baseNameVal}"]`).eq(baseNameEq).on('change', e => {
            if ($(e.currentTarget).prop('checked') == false) {
                if ($(`input[name="${detailNameVal}"]`).val()) {
                    $(e.currentTarget).prop('checked', true)
                }
            }
        })
    }
    autoCheck('come_child', 2, 'come_child_limit')
}

const main = () => {
    if (!document.querySelector('#page-entry-input-detail')) return false;

    inputDetailAction();
}
export default main;